import Loadable from '@townsquare/loadable';
import { goalSettingsRoute } from '@townsquare/routes/goal-settings';
import { noWorkspacePersonalSettingsRoute, settingsRoute } from '@townsquare/routes/settings-view';

import { goalSettingsPageResource } from './resources/goalSettings';
import { noWorkspacePersonalSettingsPageResource } from './resources/noWorkspacePersonalSettings';
import { settingsPageResource } from './resources/settings';

// Settings View
const SettingsViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "settings-view" */ './components/SettingsView'),
  loading: () => null,
});

settingsRoute.component = SettingsViewLoadable;
settingsRoute.resources = [settingsPageResource];
export const settingsRouterRoute = settingsRoute;

// No Workspace Personal Settings View
const NoWorkspacePersonalSettingsViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "settings-view" */ './components/NoWorkspacePersonalSettingsView'),
  loading: () => null,
});

noWorkspacePersonalSettingsRoute.component = NoWorkspacePersonalSettingsViewLoadable;
noWorkspacePersonalSettingsRoute.resources = [noWorkspacePersonalSettingsPageResource];
export const noWorkspacePersonalSettingsRouterRoute = noWorkspacePersonalSettingsRoute;

// Goal Settings View
const GoalSettingsViewLoadable = Loadable({
  loader: () => import(/* webpackChunkName: "goal-settings-view" */ './components/GoalSettings/GoalSettingsView'),
  loading: () => null,
});

goalSettingsRoute.component = GoalSettingsViewLoadable;
goalSettingsRoute.resources = [goalSettingsPageResource];
export const goalSettingsRouterRoute = goalSettingsRoute;
